import { render, staticRenderFns } from "./SkeletonHome.vue?vue&type=template&id=bc0e99ee"
import script from "./SkeletonHome.vue?vue&type=script&lang=js"
export * from "./SkeletonHome.vue?vue&type=script&lang=js"
import style0 from "./SkeletonHome.vue?vue&type=style&index=0&id=bc0e99ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports